import { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
} from '@mui/material';
import { Roles } from 'App';

type TypeProps = {
  isOpen: boolean;
  onClose: () => void;
  onSave: (roles: Roles[]) => void;
  roles: Roles[];
};

export const RolesModal = ({ isOpen, onClose, roles, onSave }: TypeProps) => {
  const [data, setData] = useState<Roles[]>(roles);

  const onChange = (role: Roles) =>
    setData(data.includes(role) ? data.filter((r) => r !== role) : [...data, role]);
  return (
    <Dialog maxWidth='xs' fullWidth open={isOpen} onClose={onClose} disableRestoreFocus>
      <DialogTitle>Change Roles</DialogTitle>

      <DialogContent sx={{ padding: 3 }}>
        <Box display='flex' alignItems='center' gap={4} mb={4.5}>
          <FormGroup sx={{ mb: 2 }}>
            <FormControlLabel
              label='Instructor'
              disabled={data.includes(Roles.Instructor) && data.length === 1}
              control={
                <Checkbox
                  checked={data.includes(Roles.Instructor)}
                  onChange={() => onChange(Roles.Instructor)}
                />
              }
            />
            <FormControlLabel
              label='Student'
              disabled={data.includes(Roles.Student) && data.length === 1}
              control={
                <Checkbox
                  checked={data.includes(Roles.Student)}
                  value
                  onChange={() => onChange(Roles.Student)}
                />
              }
            />
          </FormGroup>
        </Box>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            onClick={() => {
              onSave(data);
              onClose();
            }}
          >
            Save
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
